import Model from './model'

export default class GalleryImage extends Model {
  constructor() {
    super()
    this.hydrate({
      caption: '',
      created_at: '',
      file: '',
      file_url: '',
      gallery_id: '',
      id: '',
      updated_at: ''
    })
  }
}
